import React, { useState } from 'react';
import { ArrowLeft, Search, HelpCircle, Brain, Target, Lightbulb, Clock, BookOpen, Heart, PenLine } from 'lucide-react';
interface GuidanceNote {
  id: number;
  title: string;
  description: string;
  content: string;
  category: string;
  icon: React.ElementType;
}
interface GuidanceNotesLibraryProps {
  onClose: () => void;
}
export function GuidanceNotesLibrary({
  onClose
}: GuidanceNotesLibraryProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const categories = ['Tümü', 'Sınav Stresi', 'Motivasyon', 'Zaman Yönetimi', 'Öğrenme Teknikleri', 'Hedef Belirleme'];
  const guidanceNotes: GuidanceNote[] = [{
    id: 1,
    title: 'Sık Sorulan Sorular',
    description: 'Öğrencilerin rehberlik hakkında en çok merak ettiği konular',
    content: 'Bu bölümde rehberlik hizmetleri hakkında sıkça sorulan soruları bulabilirsiniz...',
    category: 'Tümü',
    icon: HelpCircle
  }, {
    id: 2,
    title: 'Öğrenme Stilleri',
    description: 'Kendi öğrenme stilinizi keşfedin ve çalışma stratejinizi belirleyin',
    content: 'Her öğrencinin kendine özgü bir öğrenme stili vardır. Görsel, işitsel veya kinestetik...',
    category: 'Öğrenme Teknikleri',
    icon: Brain
  }, {
    id: 3,
    title: 'Hedef Belirleme Rehberi',
    description: 'SMART hedefler oluşturmanın adımları ve önemi',
    content: 'Etkili hedefler belirlemek başarıya giden yolun ilk adımıdır. SMART hedefler...',
    category: 'Hedef Belirleme',
    icon: Target
  }, {
    id: 4,
    title: 'Yaratıcı Düşünme Teknikleri',
    description: 'Problem çözme ve yaratıcılığınızı geliştirmenin yolları',
    content: 'Yaratıcı düşünme, problemlere farklı açılardan bakabilme yeteneğidir...',
    category: 'Öğrenme Teknikleri',
    icon: Lightbulb
  }, {
    id: 5,
    title: 'Sınav Kaygısıyla Başa Çıkma',
    description: 'Sınav öncesi ve sırasında kaygıyı azaltmanın yolları',
    content: 'Sınav kaygısı, performansınızı olumsuz etkileyebilir. Bu kaygıyı yönetmek için...',
    category: 'Sınav Stresi',
    icon: Heart
  }, {
    id: 6,
    title: 'Verimli Ders Çalışma Yöntemleri',
    description: 'Daha az zamanda daha çok öğrenmenin sırları',
    content: 'Verimli ders çalışmak, doğru teknikleri kullanmakla başlar. Pomodoro tekniği...',
    category: 'Zaman Yönetimi',
    icon: Clock
  }, {
    id: 7,
    title: 'Motivasyon Artırma Teknikleri',
    description: 'İç motivasyonunuzu güçlendirmenin yolları',
    content: 'Motivasyon, başarıya giden yolda en önemli faktörlerden biridir. Kendinizi motive etmek için...',
    category: 'Motivasyon',
    icon: PenLine
  }, {
    id: 8,
    title: 'Etkili Not Alma Teknikleri',
    description: 'Derslerde ve kitap okurken not almanın püf noktaları',
    content: 'Etkili not alma, öğrenme sürecinin önemli bir parçasıdır. Cornell not alma yöntemi...',
    category: 'Öğrenme Teknikleri',
    icon: BookOpen
  }, {
    id: 9,
    title: 'Zaman Yönetimi Stratejileri',
    description: 'Zamanınızı daha verimli kullanmanın yolları',
    content: 'Zaman yönetimi, başarılı öğrencilerin ortak özelliğidir. Önceliklerinizi belirlemek...',
    category: 'Zaman Yönetimi',
    icon: Clock
  }];
  const filteredNotes = guidanceNotes.filter(note => {
    const matchesSearch = note.title.toLowerCase().includes(searchTerm.toLowerCase()) || note.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = activeCategory === null || activeCategory === 'Tümü' || note.category === activeCategory;
    return matchesSearch && matchesCategory;
  });
  const [selectedNote, setSelectedNote] = useState<GuidanceNote | null>(null);
  return <div className="space-y-6" data-id="element-393">
      {selectedNote ? <div className="space-y-6" data-id="element-394">
          <div className="flex items-center gap-4" data-id="element-395">
            <button onClick={() => setSelectedNote(null)} className="flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:opacity-90 transition-all" data-id="element-396">
              <ArrowLeft className="w-5 h-5" data-id="element-397" />
              Geri
            </button>
            <h1 className="text-2xl font-bold" data-id="element-398">{selectedNote.title}</h1>
          </div>
          <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-399">
            <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-400">
              <div className="prose prose-invert max-w-none" data-id="element-401">
                <div className="flex items-center gap-3 mb-4" data-id="element-402">
                  <selectedNote.icon className="w-8 h-8 text-purple-400" data-id="element-403" />
                  <span className="px-3 py-1 rounded-full bg-purple-500/20 text-purple-400 text-sm" data-id="element-404">
                    {selectedNote.category}
                  </span>
                </div>
                <p className="text-gray-300 mb-6" data-id="element-405">{selectedNote.description}</p>
                <p className="text-gray-200" data-id="element-406">{selectedNote.content}</p>
                <p className="text-gray-200 mt-4" data-id="element-407">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam auctor, nisl eget ultricies tincidunt, nisl nisl
                  aliquam nisl, eget ultricies nisl nisl eget nisl. Nullam
                  auctor, nisl eget ultricies tincidunt, nisl nisl aliquam nisl,
                  eget ultricies nisl nisl eget nisl.
                </p>
                <p className="text-gray-200 mt-4" data-id="element-408">
                  Nullam auctor, nisl eget ultricies tincidunt, nisl nisl
                  aliquam nisl, eget ultricies nisl nisl eget nisl. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit. Nullam auctor,
                  nisl eget ultricies tincidunt, nisl nisl aliquam nisl, eget
                  ultricies nisl nisl eget nisl.
                </p>
              </div>
            </div>
          </div>
        </div> : <>
          <div className="flex items-center gap-4" data-id="element-409">
            <button onClick={onClose} className="flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:opacity-90 transition-all" data-id="element-410">
              <ArrowLeft className="w-5 h-5" data-id="element-411" />
              Geri
            </button>
            <h1 className="text-2xl font-bold" data-id="element-412">Rehberlik Notları</h1>
          </div>
          <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-413">
            <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-414">
              <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6" data-id="element-415">
                <div className="relative flex-1" data-id="element-416">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-417" />
                  <input type="text" placeholder="Konular içinde ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-white/5 text-white rounded-lg pl-10 pr-4 py-2 focus:ring-2 ring-purple-500/20" data-id="element-418" />
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-419">
                  {categories.map(category => <button key={category} onClick={() => setActiveCategory(category === 'Tümü' ? null : category)} className={`px-3 py-1.5 rounded-full text-sm transition-colors ${category === 'Tümü' && activeCategory === null || category === activeCategory ? 'bg-purple-500 text-white' : 'bg-white/5 text-gray-300 hover:bg-white/10'}`} data-id="element-420">
                      {category}
                    </button>)}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-421">
                {filteredNotes.map(note => <div key={note.id} onClick={() => setSelectedNote(note)} className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600/70 to-indigo-600/70 hover:from-purple-600 hover:to-indigo-600 transition-colors cursor-pointer group" data-id="element-422">
                    <div className="relative p-4 bg-black/90 rounded-lg h-full" data-id="element-423">
                      <div className="flex flex-col h-full" data-id="element-424">
                        <note.icon className="w-6 h-6 text-purple-400 mb-3" data-id="element-425" />
                        <h3 className="text-lg font-medium group-hover:text-white transition-colors" data-id="element-426">
                          {note.title}
                        </h3>
                        <p className="text-sm text-gray-400 mt-2 line-clamp-2" data-id="element-427">
                          {note.description}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>
              {filteredNotes.length === 0 && <div className="text-center py-12 text-gray-400" data-id="element-428">
                  Arama kriterlerinize uygun rehberlik notu bulunamadı.
                </div>}
            </div>
          </div>
        </>}
    </div>;
}